<template>
    <div class="over-half-progress-product">
        <div class="OHP-data-content">
            <h1 class="OHP-data-title">进度超过一半的产品</h1>
            <div class="OHP-data-table">


                <div class="OHP-data-table-data">
                    <el-table :data=belowHalfProgressProducts height="600px" style="width: 100%;">
                        <el-table-column prop="name" label="产品名" header-align="center" align="center" width="180">
                        </el-table-column>
                        <el-table-column prop="startTime" label="产品开始开发时间" header-align="center" align="center"
                            width="180">
                        </el-table-column>
                        <el-table-column prop="endTime" label="产品结束开发时间" header-align="center" align="center">
                        </el-table-column>
                        <el-table-column prop="poName" label="产品经理" header-align="center" align="center">
                        </el-table-column>
                    </el-table>

                </div>



                <div class="change-page">


                    <div class="block">
                        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                            :current-page=currentPage :page-sizes="[10, 20, 30, 40]" :page-size=pageSize
                            layout="total, sizes, prev, pager, next, jumper" :total=totalCnt>
                        </el-pagination>
                    </div>
                </div>






            </div>
        </div>

    </div>

</template>

<script>


// 引入 ECharts
import * as echarts from 'echarts';
// 引入 axios
import axios from 'axios';
// 引入 uri
import uri from '@/util/constant';

export default {

    data() {
        return {

            overwHalfProgressProducts: [],          //  所有產品的基本四则信息
            totalCnt: 0,                    //  一共有多少条记录
            pageSize: 10,                   //  一页放多少条记录(锁定了，原来的组件是可以通过数组切换)
            currentPage: 1,                 //  默认第一页

        }
    },

    created() {
        this.pageAllBelowHalfProgressProductsMain(this.pageSize, this.currentPage);
    },
    //  方法区
    methods: {
        async pageAllBelowHalfProgressProductsMain(size, current) {
            // const xml = await axios.get(uri.serverUrl + "/situationgl/situationgl/pageAllBelowHalfProgressProductsMain?size=" + size + "&current=" + current);
            // // console.log(xml.data.data);
            // this.belowHalfProgressProducts = xml.data.data.records;               //  获取数组信息
            // this.totalCnt = xml.data.data.total;                    //  获取总记录数


            var token = localStorage.getItem('jwttoken');

            this.axios.defaults.headers.common["token"] = token;

            this.axios.get(uri.serverUrl + "/situationgl/situationgl/pageAllOverHalfProgressProductsMain?size=" + size + "&current=" + current).then(res => {

                console.log(res.data);

                this.belowHalfProgressProducts = res.data.records;
                this.totalCnt = res.data.total;
            })


        },

        // 处理每页条数变化
        handleSizeChange(newSize) {
            this.pageSize = newSize;
            this.currentPage = 1; // 重置到第一页
            this.pageAllBelowHalfProgressProductsMain(this.pageSize, this.currentPage);
        },

        // 处理页码变化
        handleCurrentChange(newPage) {
            this.currentPage = newPage;
            this.pageAllBelowHalfProgressProductsMain(this.pageSize, this.currentPage);
        },
    }


}


</script>


<style scoped>
* {
    margin: 0;
    padding: 0;
}

/* 全局控制 */
.over-half-progress-product {
    width: 100%;
    min-height: 800px;


    background-color: #f5f7fa;

    display: flex;
    flex-direction: column;
}



/* 内容区样式 */
.OHP-data-content {

    display: flex;
    flex-direction: column;

    margin: 0 auto;
    width: 1000px;
    min-height: 800px;

    /* background-color: aqua; */
    background-color: rgb(255, 255, 204);
    border-radius: 50px;

    align-items: center;
}

/* 表格标题的样式 */
.OHP-data-title {
    color: rgb(0, 47, 167);
    margin-top: 20px;
    margin-bottom: 20px;
}


.OHP-data-table{
    display: flex;
    flex-direction: column;
    width: 80%;
    min-height: 700px;
}


.OHP-data-table-data{
    width: 100%;
    height: 95%;
}

.change-page{
    height: 5%;
    width: 100%;
}
</style>